/*
 * @Author: Asadhcj asadhcj@163.com
 * @Date: 2025-05-30 14:39:01
 * @LastEditors: Asadhcj asadhcj@163.com
 * @LastEditTime: 2026-01-12 14:07:55
 * @FilePath: \betdoce-web\src\api\activity.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "./request";

export interface ActivityStatusRecord {
  id: number; // 活動ID
  user_id: number; // 用戶ID
  activity_id: number; // 活動ID
  participation_count: number; // 參與次數
  lock_count: number; // 鎖定次數
  accumulated_amount: number; // 累積金額
  target_amount: number; // 目標金額
  end_time: number; // 結束時間
  invite_link: string; // 邀請鏈接
  current_progress: number; // 當前進度
  current_amount: number; // 當前金額
  current_register_num: number; // 當前註冊人數
  is_completed: number; // 是否完成
  short?: string; // 短鏈接
  // 新增字段
  need_recharge?: number; // 是否需要充值
  recharge_end_time?: number; // 充值倒计时结束时间（时间戳，单位毫秒）
  must_recharge_amount?: number; // 充值金额
}

export interface ActivityResponse {
  status_code: number;
  data: {
    is_new_participation: boolean;
    params_str: string;
    record: ActivityStatusRecord;
    short_url: string;
  };
  count: number;
}

export interface ActivityParams {
  user_id?: number;
  activity_id?: number;
  invitation_code: string;
}
import { type PddActivityContent } from "@/api/home";

// 获取活动状态
export function getActivityStatus(data: ActivityParams) {
  return request.Post("/activity/lastcycle_status", data);
}

// 获取活动详情
export function getActivityDetails(data: ActivityParams) {
  return request.Post<any>("/activity/details", data);
}

// 参加活动 新
export function joinActivity(data: any) {
  return request.Post<any>("/pdd/v3/join", data);
}

// 查询可参加的pdd 活动 新
export function pddParticipationActivity() {
  return request.Get("/pdd/v3", {
    params: { date: new Date().getTime() },
  });
}

// 领取参加的pdd 活动 奖励 新
export function pddParticipationActivityReceiveReward(data: any) {
  return request.Post("/pdd/v3/receive_reward", data);
}

// pdd 助力完成查询
export function joinList() {
  return request.Get<any>("/activity/join_list", {
    params: { date: new Date().getTime() },
  });
}

// 拼多多助力活动
export function supportActivity(params: any) {
  return request.Get<any>("/pdd/v3/support", { params });
}

// 关闭拼多多助力活动
export function closeTask(data: any) {
  return request.Post("/activity/close_task", data);
}

// 通知派发奖金
export function copyCheck(data: any) {
  return request.Post("/pdd/v3/copy_check", data);
}
// 参与活动
export function joinPddActivity(data: any) {
  return request.Post<PddActivityContent>("/activity/join", data);
}
// 显示一次弹窗
export function oncePopup() {
  return request.Get("/popup/oncePopup");
}
// 登录时显示的弹窗
export function loginPopup() {
  return request.Get("/popup/loginPopup");
}
// 首页显示的弹窗
export function homePopup() {
  return request.Get("/popup/homePopup");
}
// 判断助力弹窗是否打开
export function checkActivityPopup(invite_code: string) {
  return request.Get<any>("/activity/popup", { params: { invite_code } });
}

// 判断加油助力弹窗是否打开
export function checkActivityBoostPopup(data: any) {
  return request.Post<any>("/activity_boost/status", data);
}

// 加油活动助力
export function actionActivityBoost(data: any) {
  return request.Post<any>("/activity_boost/action", data);
}

// 判断加油活动弹窗是否打开
export function checkActivityBoost(params: any) {
  return request.Get<any>("/activity_boost/check", { params });
}

// 检查返佣参加条件
export function checkActivityRebatePopup(params: any) {
  return request.Get<any>("/rebate_activity/check", { params });
}

// 返佣活动助力
export function actionActivityRebate(params: any) {
  return request.Get<any>("/rebate_activity/assistance", { params });
}

// 获取返佣活动页面数据
export function fetchActivityRebate(params: any) {
  return request.Get<any>("/rebate/activity/v2/page/data", {
    params: { ...params, date: new Date().getTime() },
  });
}

// 获取中奖记录列表
export function fetchActivityRebateRecords(params: any) {
  return request.Get<any>("/rebate/activity/v2/winning/records", {
    params: { ...params, date: new Date().getTime() },
  });
}

// 返佣活动领取奖励
export function fetchActivityRebateAward(id: any) {
  return request.Post<any>("/rebate/activity/v2/draw/" + id);
}

// 获取返佣VIP配置列表
export function fetchActivityRebateVipConfig() {
  return request.Get<any>("/rebate/activity/v2/config", {
    params: { date: new Date().getTime() },
  });
}

// 领取游客奖励
export function gustAward(data: any) {
  return request.Post<any>("/user/visitor/register/draw/award", data);
}

// 个人累计奖励
export function fetchInviterDetails(params?: any) {
  return request.Get<any>("/inviter_v2/inviter_details", {
    params: { ...params, date: new Date().getTime() },
  });
}

// 平台实时奖励
export function realTimeRewards(params?: any) {
  return request.Get<any>("/inviter/real_time_rewards", {
    params: { ...params, date: new Date().getTime() },
  });
}

// 获取邀请人奖励详情
export function getInviterRewards(params?: any) {
  return request.Get<any>("/inviter_v2/get_inviter_rewards", {
    params: { ...params, date: new Date().getTime() },
  });
}

// 获取VIP奖励列表
export function getVipRewardsList(params?: any) {
  return request.Get<any>("/inviter/get_vip_rewards_list", {
    params: { ...params, date: new Date().getTime() },
  });
}

// 获取首次充值奖励列表
export function getFirstRechargeRewardsList(params?: any) {
  return request.Get<any>("/inviter/get_first_recharge_rewards_list", {
    params: { ...params, date: new Date().getTime() },
  });
}

// 获取邀请奖励列表
export function getInviteRewardsList(params?: any) {
  return request.Get<any>("/inviter/get_inviter_records", {
    params: { ...params, date: new Date().getTime() },
  });
}

// v2: 查询宝箱列表
export function getTreasureChestList(params?: any) {
  return request.Get<any>("/inviter_v2/get_treasure_chest_list", {
    params: { ...params, date: new Date().getTime() },
  });
}

// v2: 领取邀请宝箱
export function openTreasureChest(data: { record_id: number }) {
  return request.Post<any>("/inviter_v2/open_treasure_chest", data);
}

// v2: 邀请奖励记录
export function getInviterRecordsV2(params?: any) {
  return request.Get<any>("/inviter_v2/get_inviter_records", {
    params: { ...params, date: new Date().getTime() },
  });
}

// v2: 奖励详情列表
export function getRewardDetailsV2(params?: any) {
  return request.Get<any>("/inviter_v2/get_reward_details", {
    params: { ...params, date: new Date().getTime() },
  });
}

export function getRewardHistory(params?: any) {
  return request.Get<any>("/loto_invite/reward/history", {
    params: { ...params, date: new Date().getTime() },
  });
}

export function getRewardDetail(params?: { reward_type?: number }) {
  return request.Get<any>("/loto_invite/reward/detail", {
    params: { ...params, date: new Date().getTime() },
  });
}

export function getRewardTeam(params?: { level?: number }) {
  return request.Get<any>("/loto_invite/reward/team", {
    params: { ...params, date: new Date().getTime() },
  });
}

export function getInviteLink(params?: any) {
  return request.Get<any>("/loto_invite/reward/get_link", {
    params: { ...params, date: new Date().getTime() },
  });
}

export function getRewardSummary(params?: any) {
  return request.Get<any>("/loto_invite/reward/summary", {
    params: { ...params, date: new Date().getTime() },
  });
}

export function getInviteConfig(params?: any) {
  return request.Get<any>("/loto_invite/reward/config", {
    params: { ...params, date: new Date().getTime() },
  });
}

export function transferInviteRewards(data?: any) {
  return request.Post<any>("/loto_invite/reward/claim_all", data);
}

export interface BetRewardTierItem {
  deposit_amount: number;
  reward_amount: number;
  status: string;
  can_claim: boolean;
}

export interface BetRewardActivityPageData {
  user_vip_level?: number;
  can_claim?: boolean;
  pending_reward_amount?: number;
  ratio_matrix?: BetRewardRatioItem[][];
}

export function getBetRewardActivityPageData() {
  return request.Get<BetRewardActivityPageData>("/bet/reward/activity/page/data", {
    params: { _t: Date.now() },
  });
}

export interface BetRewardRatioItem {
  vip_level: number;
  game_category_name: string;
  game_category_id: number;
  ratio: number;
}

export interface BetRewardRatioLevel {
  vip_level: number;
  ratio_item: BetRewardRatioItem[];
}

export interface BetRewardRatioConfigResponse {
  status_code: number;
  data: {
    user_vip_level: number;
    level_list: BetRewardRatioLevel[];
  };
  count: number;
}

export function getBetRewardActivityRatioConfig(params?: any) {
  return request.Get<BetRewardRatioConfigResponse>(
    "/bet/reward/activity/config/ratio",
    {
      params: { ...params, _t: Date.now() },
    }
  );
}

export interface BetRewardRecordDetail {
  game_category_id: number;
  game_category_name: string;
  reward_amount: number;
}

export interface BetRewardRecordItem {
  claimed_at: number;
  total_reward_amount: number;
  details: BetRewardRecordDetail[];
}

export function getBetRewardActivityRecords(params?: any) {
  return request.Get<BetRewardRecordItem[]>("/bet/reward/activity/records", {
    params: { ...params, _t: Date.now() },
  });
}

export function claimBetRewardActivity(data?: any) {
  return request.Post<any>("/bet/reward/activity/claim", data);
}

export function incrementDailySpinCount(data: { id: number; field: "popup_count" | "click_count" }) {
  return request.Post<any>("/daily-spin-activity/increment/count", data);
}

export interface DailySpinRewardItem {
  amount: number;
  probability: number;
}

export interface DailySpinVipRewardConfig {
  vip_level: number;
  rewards: DailySpinRewardItem[];
}

export interface DailySpinUserSpinData {
  today_spin_count: number;
  remaining_spin_count: number;
  total_spin_count: number;
}

export interface DailySpinActivityPageData {
  id: number;
  activity_id: string;
  activity_name: string;
  start_time: number;
  end_time: number;
  description: string;
  user_spin_data: DailySpinUserSpinData;
  vip_reward_config: DailySpinVipRewardConfig;
}

export function getDailySpinActivityPageData() {
  return request.Get<DailySpinActivityPageData>("/daily-spin-activity/page/data", {
    params: { _t: Date.now() },
  });
}

export interface DailySpinActionResponse {
  success: boolean;
  reward_amount_type: string;
  reward_amount: number;
  remaining_spin_count: number;
  wallet_balance: number;
}

export function spinDailySpinActivity(data: { id: number }) {
  return request.Post<DailySpinActionResponse>("/daily-spin-activity/spin", data);
}

export interface DailySpinDepositTier {
  tier_index: number;
  deposit_amount: number;
  spin_count: number;
  is_completed: boolean;
}

export interface DailySpinDepositProgressResponse {
  activity_name: string;
  progress_list: DailySpinDepositTier[];
  today_deposit_amount: number;
}

export function getDailySpinDepositProgress(params: { id: number }) {
  return request.Get<DailySpinDepositProgressResponse>("/daily-spin-activity/deposit/progress", { params: { ...params, _t: Date.now() } });
}

export interface DailySpinPlatformRecordItem {
  uuid: number;
  username: string;
  avatar: string;
  reward_amount: number;
  created_at: number;
}

export interface DailySpinPlatformRecordsResponse {
  records: DailySpinPlatformRecordItem[];
}

export function getDailySpinPlatformRecords(params: { id: number }) {
  return request.Get<DailySpinPlatformRecordsResponse>("/daily-spin-activity/platform/records", { params: { ...params, _t: Date.now() } });
}

export interface DailySpinMyRecordItem {
  uuid: number;
  username: string;
  avatar: string;
  reward_amount: number;
  created_at: number;
}

export interface DailySpinMyRecordsResponse {
  records: DailySpinMyRecordItem[];
}

export function getDailySpinMyRecords(params: { id: number }) {
  return request.Get<DailySpinMyRecordsResponse>("/daily-spin-activity/my/records", { params: { ...params, _t: Date.now() } });
}

// 获取下载活动状态
export function getDownloadActivityStatus() {
  return request.Get<any>("/download_activity/get_status", { params: { _t: Date.now() } });
}


// 获取下载活动配置
export function getDownloadActivityConfig() {
  return request.Get<any>("/download_activity/get_config", { params: { _t: Date.now() } });
}

// 获取下载奖励是否生成
export function getDownloadActivityRecord() {
  return request.Get<any>("/download_activity/get_record", { params: { _t: Date.now() } });
}